import helper from './helper'

export default {
  async getById(id) {
    return await helper.get(`/api/channels/${id}`)
  },
  async getAll() {
    return await helper.get(`/api/channels`)
  },
  async create(item) {
    return await helper.post(`/api/channels`, item)
  },
  async update(item) {
    return await helper.put(`/api/channels`, item)
  },
  async remove(id) {
    return await helper.delete(`/api/channels/${id}`)
  }
}
